// extracted by mini-css-extract-plugin
export default {"createAdCheckboxContainer":"StandartCheckbox_createAdCheckboxContainer__Den7x","createAdCheckbox":"StandartCheckbox_createAdCheckbox__oAxFC"};